// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./components/Panel/Panel.less
// module id = 223
// module chunks = 2